<script lang="ts" setup>
export interface VydavokProjektuZdrojeFinancovaniaProps {
  /** Id polozky v Pinii.*/
  polozkaId: string
  druhPolozky: DruhVydavku
  zdrojeFinancovania: object
}

import { useI18n } from 'vue-i18n'
import { useRozpocetStore } from '/@src/stores/rozpocet'
import { DruhVydavku } from '/@src/stores/rozpocet/types'

const { t } = useI18n()

const props = withDefaults(defineProps<VydavokProjektuZdrojeFinancovaniaProps>(), {})
const rozpocetStore = useRozpocetStore()
const vydavok = rozpocetStore.getPolozka(props.druhPolozky, props.polozkaId)!
const checkboxesModel = rozpocetStore.getPolozkaCheckboxes(
  props.druhPolozky,
  props.polozkaId
)!

const available = (typZdroja: string) => {
  return (
    props.zdrojeFinancovania?.find((zdroj) => {
      return zdroj?.typZdrojaFinancovania === typZdroja
    })?.povolene ?? false
  )
}
</script>

<template>
  <div class="mb-6">
    <IDSKCheckbox
      v-if="available('POO') || available('POO_DPH')"
      :checked="checkboxesModel.POO"
      @is-checked="() => (checkboxesModel.POO = !checkboxesModel.POO)"
    >
      <template #default>
        {{ t('zoppm.step9.form.checkbox1') }}
      </template>
      <template #hidden-content>
        <IDSKInput
          v-if="available('POO')"
          v-model.number="vydavok.zdrojeFinancovania.POO.suma.sumaEurBezDph"
          type="number"
          min="0"
          :label="t('zoppm.step9.form.sumFromPlan')"
        />
        <IDSKInput
          v-if="available('POO_DPH')"
          v-model.number="vydavok.zdrojeFinancovania.POO.suma.dphEur"
          type="number"
          min="0"
          :label="t('zoppm.step9.form.taxNumber')"
        />
      </template>
    </IDSKCheckbox>

    <IDSKCheckbox
      v-if="available('VLASTNE_ZDROJE')"
      :checked="checkboxesModel.VLASTNE_ZDROJE"
      @is-checked="
        () => (checkboxesModel.VLASTNE_ZDROJE = !checkboxesModel.VLASTNE_ZDROJE)
      "
    >
      <template #default>
        {{ t('zoppm.step9.form.checkbox2') }}
      </template>
      <template #hidden-content>
        <IDSKInput
          v-model.number="vydavok.zdrojeFinancovania.VLASTNE_ZDROJE.suma.sumaDphEur"
          type="number"
          min="0"
          :label="t('zoppm.step9.form.checkbox2Sum')"
        />
      </template>
    </IDSKCheckbox>

    <IDSKCheckbox
      v-if="available('STATNY_ROZPOCET')"
      :checked="checkboxesModel.STATNY_ROZPOCET"
      @is-checked="
        () => (checkboxesModel.STATNY_ROZPOCET = !checkboxesModel.STATNY_ROZPOCET)
      "
    >
      <template #default>
        {{ t('zoppm.step9.form.checkbox3') }}
      </template>
      <template #hidden-content>
        <IDSKInput
          v-model.number="vydavok.zdrojeFinancovania.STATNY_ROZPOCET.suma.sumaDphEur"
          type="number"
          min="0"
          :label="t('zoppm.step9.form.checkbox3Sum')"
        />
      </template>
    </IDSKCheckbox>

    <IDSKCheckbox
      v-if="available('INE_ZDROJE')"
      :checked="checkboxesModel.INE_ZDROJE"
      @is-checked="() => (checkboxesModel.INE_ZDROJE = !checkboxesModel.INE_ZDROJE)"
    >
      <template #default>
        {{ t('zoppm.step9.form.checkbox4') }}
      </template>
      <template #hidden-content>
        <IDSKInput
          v-model.number="vydavok.zdrojeFinancovania.INE_ZDROJE.suma.sumaDphEur"
          type="number"
          min="0"
          :label="t('zoppm.step9.form.checkbox4Sum')"
        />
      </template>
    </IDSKCheckbox>
  </div>
</template>

<style scoped></style>
